export const ORDER_CHANNELS = ["POS", "KIOSK", "QR", "WEB"];

export const normalizeBlockedOrderChannels = (value) => {
  if (!Array.isArray(value)) return [];

  return Array.from(
    new Set(
      value
        .map((channel) => String(channel || "").trim().toUpperCase())
        .filter(Boolean),
    ),
  );
};

export const isChannelOrderingBlocked = (features, channel) => {
  const normalizedChannel = String(channel || "").trim().toUpperCase();
  if (!normalizedChannel) return Boolean(features?.isOrderBlocked);

  const blockedOrderChannels = normalizeBlockedOrderChannels(
    features?.blockedOrderChannels,
  );

  return (
    Boolean(features?.isOrderBlocked) ||
    blockedOrderChannels.includes(normalizedChannel)
  );
};
